/**
 * Created by Ning Jiang on 11/22/2016.
 */

//Important! This pixi import business need to be at the top of the file. We need to attach PIXI to the window scope in order for our code to work, because we use PIXI in the old global way.
//The new way would be like this for example: new Sprite(); + A "normal"  import of Sprite from pixi."Not like we normaly
import "pixi-spine";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinGameModuleConfig} from "./HarlequinGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {REWinFieldController} from "./keypad/REWinFieldController";

require("gsap");


export class Harlequin extends SlotGame {
    public static timelineReelsController:TimelineReelsController;
    private static gameRoundManager:GameRoundManager;

    constructor() {
        super(HarlequinGameModuleConfig.instance);
    }

    protected initGame():void {
        if(GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            Harlequin.timelineReelsController = TimelineReelsController.instance;
            Harlequin.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        } else {
            super.initGame();
        }

    }

    protected createWinFieldController():WinFieldController {
        return new REWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M3",
                    "L2",
                    "M5",
                    "M2",
                    "L3"
                ],
                [
                    "L3",
                    "L1",
                    "M4",
                    "L3",
                    "L1"
                ],
                [
                    "L4",
                    "M2",
                    "L3",
                    "L4",
                    "L1"
                ],
                [
                    "M5",
                    "M3",
                    "L2",
                    "L3",
                    "M2"
                ],
                [
                    "M1",
                    "L1",
                    "L2",
                    "M4",
                    "L3"
                ]
            ],
            "evaluatedArea": [
                [
                    "L2",
                    "M5",
                    "M2"
                ],
                [
                    "L1",
                    "M4",
                    "L3"
                ],
                [
                    "M2",
                    "L3",
                    "L4"
                ],
                [
                    "M3",
                    "L2",
                    "L3"
                ],
                [
                    "L1",
                    "L2",
                    "M4"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWins": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1.2,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "wildOverlaysBefore": [
                false,
                false,
                false,
                false,
                false
            ],
            "wildOverlayReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "wildMultipliersBefore": [
                0,
                0,
                0,
                0,
                0
            ],
            "wildMultipliers": [
                0,
                0,
                0,
                0,
                0
            ],
            "scattersCollected": 0,
            "wildsCollected": [
                0,
                0,
                0,
                0,
                0
            ],
            "respinActive": false,
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L1",
                    "L4",
                    "L3"
                ],
                [
                    "L3",
                    "M5",
                    "L2"
                ],
                [
                    "L1",
                    "M5",
                    "L3"
                ],
                [
                    "M3",
                    "M4",
                    "L3"
                ],
                [
                    "M3",
                    "L4",
                    "L3"
                ]
            ],
            "scattersFSCollectedBefore": [
                0,
                0,
                0,
                0,
                0
            ],
            "scattersFSCollectedAfter": [
                0,
                0,
                0,
                0,
                0
            ],
            "extraScatterThisFSSpin": [
                0,
                0,
                0,
                0,
                0
            ],
            "wildDrop": [
                false,
                false,
                false,
                false,
                false
            ],
            "scattersCollectedFSBefore": 0,
            "scattersCollectedFSAfter": 0,
            "totalRespinWin": 0,
            "extraSpinsAwardedThisSpin": 0,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 70
                }
            ],
            "wasFeatureBuy": false,
            "firstSpinWildDrop": false
        };
    }
}